import { BlueprintInstanceType } from '@rta/rta-blueprint-library';
import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { DisplayMode } from '@r-core';

type BacksplashViewState = {
	unstackedGroups: Set<string>;
	unstackGroup: (groupKey: string) => void;
	stackGroup: (groupKey: string) => void;
	canStackGroup: (groupKey: string) => boolean;
	getGroupKeyForBacksplash: (backsplashId: string) => string | null;
	isGroupUnstacked: (groupKey: string) => boolean;
};

export const unstackBacksplashesMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Unstack Backsplashes',
		displayModes: [DisplayMode.Backsplash, DisplayMode.BacksplashManufacturing],
		isVisible: ({ controller, context, refMap }): boolean => {
			if (controller.readonly) return false;
			if (refMap?.type !== BlueprintInstanceType.Backsplash) return false;

			// Get the view state from the kitchen object
			const viewState = (controller.kitchen as any).__backsplashViewState as BacksplashViewState | undefined;
			if (!viewState) return false;

			// Get the group key for this backsplash
			const groupKey = viewState.getGroupKeyForBacksplash(context.id);
			if (!groupKey) return false;

			// Only show if the group is currently stacked (not unstacked)
			return !viewState.isGroupUnstacked(groupKey);
		},
		onClick: ({ context, controller }): void => {
			const viewState = (controller.kitchen as any).__backsplashViewState as BacksplashViewState | undefined;
			if (!viewState) return;

			const groupKey = viewState.getGroupKeyForBacksplash(context.id);
			if (groupKey) {
				viewState.unstackGroup(groupKey);
			}
		}
	}
};
